import {
  ArrowsClockwise,
  Calculator,
  Copy,
  Export,
  File,
  FileText,
  FloppyDisk,
  LinkSimple,
  Plus,
  Trash,
} from '@phosphor-icons/react';

import { ActionButton, ButtonText, Divider, ToolbarContainer } from './styles';

export const ActionToolbar = () => {
  return (
    <ToolbarContainer>
      <ActionButton>
        <FloppyDisk size={16} />
        <ButtonText>Save</ButtonText>
      </ActionButton>

      <ActionButton>
        <FloppyDisk size={16} />
        <ButtonText>Save & Close</ButtonText>
      </ActionButton>

      <Divider />

      <ActionButton>
        <Plus size={16} />
        <ButtonText>New Order</ButtonText>
      </ActionButton>

      <Divider />

      <ActionButton>
        <Trash size={16} />
        <ButtonText>Delete</ButtonText>
      </ActionButton>

      <Divider />

      <ActionButton>
        <File size={16} />
        <ButtonText>Generate Document</ButtonText>
      </ActionButton>

      <Divider />

      <ActionButton>
        <ArrowsClockwise size={16} />
        <ButtonText>Refresh</ButtonText>
      </ActionButton>

      <ActionButton>
        <LinkSimple size={16} />
        <ButtonText>Open a new tab</ButtonText>
      </ActionButton>

      <ActionButton>
        <Copy size={16} />
        <ButtonText>Copy Order</ButtonText>
      </ActionButton>

      <Divider />

      <ActionButton>
        <Export size={16} />
        <ButtonText>Submit Order</ButtonText>
      </ActionButton>

      <ActionButton>
        <Calculator size={16} />
        <ButtonText>Calculate Tax</ButtonText>
      </ActionButton>

      <ActionButton>
        <FileText size={16} />
        <ButtonText>Word Templates</ButtonText>
      </ActionButton>
    </ToolbarContainer>
  );
};
